// extracted by mini-css-extract-plugin
var _1 = "ra-no-wishlist";
var _2 = "ra-first-p";
export { _1 as "noWishlistCls", _2 as "noWishlistFirstParagraphCls" }
